import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_BASE_URL;

// Shared by every RTK Query API slice: attaches the bearer token from the auth
// slice, and on a 401 clears the session and sends the user back to login.
// Centralized so this behavior can no longer drift between slices.
export const createAuthBaseQuery = () => async (args, api, extraOptions) => {
    const result = await fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.authData?.access_token;
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    })(args, api, extraOptions);

    if (result?.error && result.error.status === 401) {
        localStorage.clear();
        window.location.href = '/';
    }
    return result;
};
